if (!customElements.get('inkcloud-reading-room')) {
  customElements.define('inkcloud-reading-room', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      const {signal} = this.controller;
      this.entries = [...this.querySelectorAll('[data-reader-entry]')].sort((a,b) => Number(b.dataset.published)-Number(a.dataset.published));
      this.panels = new Map([...this.querySelectorAll('[data-reader-panel]')].map(panel => [panel.dataset.readerPanel,panel]));
      this.searchIndex = new Map(this.entries.map(entry => {
        const panel = this.panels.get(entry.dataset.readerEntry);
        const template = panel?.querySelector('template[data-reader-body]');
        const body = template?.content.textContent || panel?.querySelector('.ic-reader__body')?.textContent || '';
        return [entry.dataset.readerEntry, (entry.dataset.search + ' ' + body).toLocaleLowerCase()];
      }));
      this.index = this.querySelector('.ic-reader__index');
      this.pane = this.querySelector('.ic-reader__pane');
      this.search = this.querySelector('[data-reader-search]');
      this.count = this.querySelector('[data-reader-count]');
      this.empty = this.querySelector('[data-reader-empty]');
      this.archives = this.querySelector('[data-reader-archives]');
      this.topics = [...this.querySelectorAll('[data-reader-topic]')];
      this.category = 'all';
      this.selected = null;
      for (const entry of this.entries) this.index.append(entry);
      this.search.value = '';
      this.search.disabled = false;
      for (const topic of this.topics) topic.disabled = false;
      this.addEventListener('click', event => {
        const topic = event.target.closest('[data-reader-topic]');
        if (topic && this.contains(topic)) {
          this.category = topic.dataset.readerTopic;
          this.selected = null;
          this.filter();
          return;
        }
        const entry = event.target.closest('[data-reader-entry]');
        if (!entry || !this.contains(entry) || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey || event.button !== 0) return;
        event.preventDefault();
        this.select(entry.dataset.readerEntry);
        {
          cancelAnimationFrame(this.scrollFrame);
          this.scrollFrame = requestAnimationFrame(() => this.pane.scrollIntoView({block:'start',behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'}));
        }
      }, {signal});
      this.search.addEventListener('input', () => this.filter(), {signal});
      this.filter();
    }
    filter() {
      const query = this.search.value.trim().toLocaleLowerCase();
      const matching = this.entries.filter(entry => (this.category === 'all' || entry.dataset.category === this.category) && (!query || this.searchIndex.get(entry.dataset.readerEntry).includes(query)));
      const visible = matching.slice(0,24);
      const ids = new Set(visible.map(entry => entry.dataset.readerEntry));
      for (const entry of this.entries) entry.hidden = !ids.has(entry.dataset.readerEntry);
      for (const topic of this.topics) topic.setAttribute('aria-pressed',String(topic.dataset.readerTopic === this.category));
      this.count.textContent = `${visible.length} ${visible.length===1?this.dataset.one:this.dataset.many}`;
      this.empty.hidden = visible.length > 0;
      const total = this.category === 'all' ? Number(this.dataset.total) : Number(this.topics.find(topic => topic.dataset.readerTopic === this.category)?.dataset.total || 0);
      this.archives.hidden = !query && total <= 24;
      for (const link of this.archives.querySelectorAll('[data-reader-archive]')) link.hidden = this.category !== 'all' && link.dataset.readerArchive !== this.category;
      this.select(ids.has(this.selected) ? this.selected : visible[0]?.dataset.readerEntry);
    }
    select(id) {
      this.selected = id;
      for (const entry of this.entries) {
        if (entry.dataset.readerEntry === id) entry.setAttribute('aria-current','true');
        else entry.removeAttribute('aria-current');
      }
      for (const [key,panel] of this.panels) {
        panel.hidden = key !== id;
        if (key === id) {
          const template = panel.querySelector('template[data-reader-body]');
          if (template) {
            const content = template.content.cloneNode(true);
            for (const image of content.querySelectorAll('img')) {
              image.loading = 'lazy';
              image.decoding = 'async';
            }
            template.replaceWith(content);
          }
        }
      }
    }
    disconnectedCallback() {
      this.controller?.abort();
      cancelAnimationFrame(this.scrollFrame);
    }
  });
}
